import classNames from 'classnames';
import includes from 'lodash/includes';
import find from 'lodash/find';
import {
    CATEGORY_TEMPLATE,
    NEARBY_CITIES_TEMPLATE,
    TRENDING_SEARCHES_TEMPLATE,
    COLLECTION_TEMPLATE,
    SHARED_BUCKET_SPACING_CLASSES,
    NON_EVENT_BUCKET_SPACING_CLASSES,
    BUCKET_WRAPPER_WITH_DECORATION_CLASSES,
    DECORATIVE_IMAGE_PLACEMENT_MAP,
    EDITORIAL_ARTICLES_BUCKET_KEY,
    ORGANIZER_FOLLOW_TEMPLATE,
} from '../../../../constants';

const NON_EVENT_BUCKETS = [
    CATEGORY_TEMPLATE,
    NEARBY_CITIES_TEMPLATE,
    TRENDING_SEARCHES_TEMPLATE,
    ORGANIZER_FOLLOW_TEMPLATE,
];
/*
 Returns the decorativeImagePlacement matching the selector and adds it to an array to prevent duplicates
*/
const _getDecorativeImagePlacement = (key, usedDecorativeImages) => {
    const decorativeImage = find(
        DECORATIVE_IMAGE_PLACEMENT_MAP,
        (decorativeImageData) => {
            const { selectors } = decorativeImageData;

            let isKeyMappedInPlacementMap;

            if (!includes(usedDecorativeImages, selectors)) {
                isKeyMappedInPlacementMap = includes(selectors, key);

                if (isKeyMappedInPlacementMap) {
                    usedDecorativeImages.push(selectors);
                }
            }

            return isKeyMappedInPlacementMap;
        },
    );

    return decorativeImage || undefined;
};

export const getDecorativeImage = (decorativeImages, key, usedImages) => {
    let decorativeImage;

    const decorationPlacement = _getDecorativeImagePlacement(key, usedImages);

    if (decorationPlacement) {
        decorativeImage = decorativeImages[decorationPlacement.urlSelector];
    }

    return { decorationPlacement, decorativeImage };
};

export const getBucketClasses = (key, decorativeImage, template) => {
    // Only the articles and collections section should have a gray background
    const shouldHaveBackground =
        key === EDITORIAL_ARTICLES_BUCKET_KEY || key === COLLECTION_TEMPLATE;

    const containerClasses = classNames({
        'eds-bg-color--grey-100': shouldHaveBackground,
    });

    let spacingClasses = SHARED_BUCKET_SPACING_CLASSES;

    if (includes(NON_EVENT_BUCKETS, template)) {
        spacingClasses = NON_EVENT_BUCKET_SPACING_CLASSES;
    }

    const bucketWrapperClasses = classNames(spacingClasses, {
        [BUCKET_WRAPPER_WITH_DECORATION_CLASSES]: decorativeImage,
        'collection-bucket-top-spacing': key === COLLECTION_TEMPLATE,
    });

    return { containerClasses, bucketWrapperClasses };
};
